Vue.component('vq-tabs', {
  delimiters: ['[[', ']]'],
  mixins: [eventHubMixin],
  data() {
		return {
			active: 0,
			focused: null,
		};
	},
	props: {
		tabs: {
			type: Array,
			default: () => [],
		},
		listClasses: {
			type: [String, Array],
			default: 'border-b-2'
		},
		itemClasses: [String, Array],
		contentClasses: [String, Array],
		name: {
      type: String,
      default: 'default'
    },
		loading: {
			type: Boolean,
			default: true
		}
	},
	created () {
    this.eventHub.$on(`tab:${this.name}:change`, (index) => {
			this.active = index;
			this.$emit('change', index)
    })
  },
	mounted() {
	},
	methods: {
		onClick(index) {
			console.log(index)
			this.active = index;
			this.$emit('change', index)
		},
		onFocus(index) {
			this.focused = index;
		},
		onFocusout() {
			this.focused = null;
		},
		isActive(index) {
			return this.active === index;
		},
		isFocused(index) {
			return this.focused === index;
		}
  },
  template: `<div class="container">
  <div class="flex justify-between items-center mb-10">
    <ul class="tabs flex mb-20px border-b-2 border-gray-100" :class="listClasses">
        <li
          v-for="(tab, index) in tabs"
          :key="index"
          tabindex="0"
          @focus="onFocus(index)"
          @focusout="onFocusout()"
          @click="onClick(index)"
          @keyup.enter="onClick(index)"
          class="focus:outline-none"
          :class="{ 'is-active': isActive(index), 'is-loading' : loading }"
        >
          <span class="tab-toggle">[[ tab.label ]]</span>
        </li>
    </ul>
    <div class="flex-none">
      <slot name="search"></slot>
    </div>
  </div>
  <div class="tabs-content relative">
    <template v-for="(tab, index) in tabs">
        <div
          v-if="isActive(index)"
          :key="index"
          :class="contentClasses"
          class="duration-300 max-w-full top-0"
        >
          <slot :name="tab.name"></slot>
        </div>
    </template>
  </div>
</div>`
})